import { ChangeFarmsList } from "@/components/ChangeFarmsList"
import { setActiveFeature } from "@/redux/actions"
import { getIsChangeFarmsOpenFromState } from "@/redux/selectors"
import { useRootDispatch } from "@/redux/useRootDispatch"
import { useRootSelector } from "@/redux/useRootSelector"
import { AlertDialog } from "@/theme"
import { useTranslation } from "react-i18next"

export function ChangeFarmAccountDialog() {
  const { t } = useTranslation()
  const isOpen = useRootSelector(getIsChangeFarmsOpenFromState)
  const dispatch = useRootDispatch()

  const onClose = () => {
    dispatch(setActiveFeature(undefined))
  }
  return (
    <AlertDialog
      isOpen={isOpen}
      titleElement={t("changeFarmAccount")}
      onClose={onClose}
    >
      <ChangeFarmsList />
    </AlertDialog>
  )
}
